/** Asks before a command acts. Cancelling returns false, which keeps the palette open. */
export function confirmCommandAction(message: string, action: () => void): false | void {
  const nativeConfirm = window.confirm.bind(window);
  if (!nativeConfirm(message)) {
    return false;
  }

  action();
  return undefined;
}
